import { FEATURE_FLAGS } from '../../../../featureFlags';
import Bot from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-bots'),
      meta: {
        superAdminOnly: true,
        permissions: ['administrator'],
        // ACESSO-01 (L8b): os robôs são da plataforma (`Acesso::Mapa::SO_DO_SUPER_ADMIN`), e não têm escopo. O das
        // integrações, travado, é o mais perto: o robô manda a conversa para fora e guarda o token. Sem o
        // `superAdminOnly`, a porta continuaria fechada a todo membro da conta.
        escopos: ['integrations:manage'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'agent_bots',
          component: Bot,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator'],
            escopos: ['integrations:manage'],
          },
        },
      ],
    },
  ],
};
